export const COMPANY_URL = 'https://www.jmdc.co.jp/';
